<mc-list [dataListId]="dataListId" [listControl]="listControl">
  <ng-template mcListItem let-team>
    <mat-list-item>
      <mc-team-avatar [team]="team" size="small" [truncate]="true"></mc-team-avatar>
      <button *ngIf="canEdit" type="button" mat-icon-button matTooltip="Remove Team" [disabled]="team.Id | mcIncludedIn : removing" (click)="onRemoveTeam(team.Id)">
        <mat-icon [fontSet]="'project-titan'" [fontIcon]="'icon-trash'"></mat-icon>
      </button>
    </mat-list-item>
  </ng-template>

  <ng-template mcEmptyList>
    <p>No teams have access to this project.</p>
  </ng-template>

  <ng-template mcAllItemsLoadedList>
    <p>All teams loaded.</p>
  </ng-template>
</mc-list>